import React from 'react';
import { useTranslation } from 'react-i18next';
import type { AgreementStatus } from '@hero/schema';
import { cn } from '@hero/web-lib';
import { Badge } from '../../../ui/Badge';

const STATUS_CLASSES: Record<AgreementStatus, string> = {
  new: 'bg-amber-50 text-amber-700 border-transparent',
  active: 'bg-green-50 text-green-700 border-transparent',
  canceled: 'bg-gray-100 text-gray-600 border-transparent',
  terminated: 'bg-red-50 text-red-700 border-transparent',
  expired: 'bg-red-50 text-red-700 border-transparent',
};

export interface AgreementStatusBadgeProps {
  status: AgreementStatus;
  className?: string;
}

export function AgreementStatusBadge({ status, className }: AgreementStatusBadgeProps) {
  const { t } = useTranslation(['m-agreement']);
  return (
    <Badge variant="outline" className={cn(STATUS_CLASSES[status], className)}>
      {t(`status.${status}`)}
    </Badge>
  );
}
